import React from "react";
import { Box, Group, Drawer, Button, SegmentedControl, Select, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import PickerDate from "../../components/general/PickerDate";

const DiscountMasterFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateFilter,
    fnFilter
}) => {

    const [data, setData] = React.useState({
        isActive: stateFilter.isActive,
        deductedFrom: stateFilter.deductedFrom,
        type: stateFilter.type,
        validFromDari: stateFilter.validFromDari,
        validFromSampai: stateFilter.validFromSampai,

        validToDari: stateFilter.validToDari,
        validToSampai: stateFilter.validToSampai,
    });

    const handleFilter = () => {
        fnFilter({
            isActive: data.isActive,
            deductedFrom: data.deductedFrom,
            type: data.type,

            validFromDari: data.validFromDari,
            validFromSampai: data.validFromSampai,

            validToDari: data.validToDari,
            validToSampai: data.validToSampai,
        })
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            isActive: stateDefaultFilter.isActive,
            deductedFrom: stateDefaultFilter.deductedFrom,
            type: stateDefaultFilter.type,

            validFromDari: stateDefaultFilter.validFromDari,
            validFromSampai: stateDefaultFilter.validFromSampai,

            validToDari: stateDefaultFilter.validToDari,
            validToSampai: stateDefaultFilter.validToSampai,
        }))
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Data Voucher</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>
                    <InputWrapperCustom
                        stateMT="0rem"
                        stateLabel='Pemotongan Voucher'
                        stateWithAsterisk={false}
                        stateError=''
                        stateDescription=''
                    >
                        <Select
                            value={data.deductedFrom}
                            placeholder="Voucher dipotong dari"
                            description=''
                            onChange={(val) => setData(d => ({ ...d, deductedFrom: val }))}
                            data={[
                                { value: utils.flagAll, label: 'Semua' },
                                // { value: utils.discountDeductedFrom.item.value, label: utils.discountDeductedFrom.item.label },
                                { value: utils.discountDeductedFrom.jasa.value, label: utils.discountDeductedFrom.jasa.label },
                                { value: utils.discountDeductedFrom.total.value, label: utils.discountDeductedFrom.total.label }
                            ]}
                        />
                    </InputWrapperCustom>

                    <Select
                        mt='1rem'
                        value={data.type}
                        label="Tipe Voucher"
                        placeholder="Tipe Voucher"
                        withAsterisk={false}
                        description=''
                        onChange={(val) => setData(d => ({ ...d, type: val }))}
                        data={[
                            { value: utils.flagAll, label: 'Semua' },
                            { value: utils.discountType.percent.value, label: utils.discountType.percent.label },
                            { value: utils.discountType.rupiah.value, label: utils.discountType.rupiah.label },
                        ]}
                    />

                    <Group mt='1rem' position='apart' noWrap grow spacing='xs'>
                        <PickerDate
                            stateDate={data.validFromDari}
                            stateVariant="default"
                            stateClearable={true}
                            stateMinDate={null}
                            fnSetDate={(val) => setData(d => ({ ...d, validFromDari: val }))}

                            stateFormat='DD MMM YYYY'
                            stateLabel='Valid from (Dari)'
                            statePlaceHolder='Valid from'
                            stateWithAsterisk={false}
                            stateDescription=''
                            stateError=''
                        />

                        <PickerDate
                            stateDate={data.validFromSampai}
                            stateVariant="default"
                            stateClearable={true}
                            stateMinDate={data.validFromDari}
                            fnSetDate={(val) => setData(d => ({ ...d, validFromSampai: val }))}

                            stateFormat='DD MMM YYYY'
                            stateLabel='Valid from (Sampai)'
                            statePlaceHolder='Valid from'
                            stateWithAsterisk={false}
                            stateDescription=''
                            stateError=''
                        />
                    </Group>

                    <Group mt='1rem' position='apart' noWrap grow spacing='xs'>
                        <PickerDate
                            stateDate={data.validToDari}
                            stateVariant="default"
                            stateClearable={true}
                            stateMinDate={null}
                            fnSetDate={(val) => setData(d => ({ ...d, validToDari: val }))}

                            stateFormat='DD MMM YYYY'
                            stateLabel='Valid to (Dari)'
                            statePlaceHolder='Valid to'
                            stateWithAsterisk={false}
                            stateDescription=''
                            stateError=''
                        />

                        <PickerDate
                            stateDate={data.validToSampai}
                            stateVariant="default"
                            stateClearable={true}
                            stateMinDate={data.validToDari}
                            fnSetDate={(val) => setData(d => ({ ...d, validToSampai: val }))}

                            stateFormat='DD MMM YYYY'
                            stateLabel='Valid to (Sampai)'
                            statePlaceHolder='Valid to'
                            stateWithAsterisk={false}
                            stateDescription=''
                            stateError=''
                        />
                    </Group>

                    <Box mt='1rem' mb='3rem'>
                        <InputWrapperCustom
                            stateLabel="Status Voucher"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.isActive}
                                onChange={(val) => setData(d => ({ ...d, isActive: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    { label: 'Aktif', value: '1' },
                                    { label: 'Non Aktif', value: '0' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={handleReset}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            color='teal'
                            onClick={handleFilter}
                        >
                            Filter
                        </Button>
                    </Group>
                </Box>
            </Drawer>
        </React.Fragment>
    )
}

export default DiscountMasterFilter;